import { useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import QRCode from "react-qr-code";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useParams } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import "./pickup.css";
import logoTKI from "../../assets/images/logo-company.svg";
const PickupStudentScanMobile = () => {
  const location = useLocation();
  const query = useParams();

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  const handleRefresh = async () => {};

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        {/* <PullToRefresh className="text-center h-full" onRefresh={handleRefresh}> */}
        <div className="text-left h-full px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
          <section className="mt-1 w-full h-[calc(100vh-136px)] justify-between flex flex-col items-center gap-">
            <p className="text-sm font-medium">Nama Anak</p>
            <p className="text-lg font-bold text-center">
              {query.studentName} - {query.grade}
            </p>

            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={query.studentId}
              viewBox={`0 0 256 256`}
            />
            <p className="text-sm font-medium text-center">
              Untuk melakukan penjemputan, mohon diarahkan ke aplikasi anjungan
            </p>
            <p className="text-sm font-normal text-[#8F8F8F]">Powered By</p>
            <img width={95} src={logoTKI} alt="" />
          </section>
        </div>
        {/* </PullToRefresh> */}
      </div>
    </>
  );
};

export default PickupStudentScanMobile;
